import CalistaCompanyAdminRoute from './CalistaCompanyAdminRoute'

const routes = [
    new CalistaCompanyAdminRoute()
]

export default routes
